<ng-container *ngIf="!prefilled">
    <mat-form-field class="mat-form-field-fluid mat-phone-input phone-input-wrapper">
        <mat-label class="phone-input-label" [attr.data-test-id]="testId + '.label'">{{ options.inputPlaceholder }}</mat-label>
        <mat-intl-tel-input
            [cssClass]="'mat-mdc-form-field mat-mdc-text-field-wrapper w-100' + (phoneElement?.control?.errors ? ' ng-invalid' : '')"
            [preferredCountries]="options.preferredCountries"
            [enablePlaceholder]="options.enablePlaceholder"
            [enableSearch]="options.searchCountryFlag"
            [required]="options.required"
            [format]="options.numberFormat"
            [searchPlaceholder]="'Search Country'"
            [onlyCountries]="options.onlyCountries"
            [(ngModel)]="value"
            name="phone"
            [id]="id"
            [inputAriaLabel]="options.inputPlaceholder"
            #phoneInput
            autocomplete="off"
            [data-test-id]="testId"
        ></mat-intl-tel-input>
        <mat-error *ngIf="phoneElement && phoneElement.control" [attr.data-test-id]="testId + '.invalid-error'">
            <ng-container *ngIf="phoneElement.control.hasError('required')">Please enter {{ label }}.</ng-container>
            <ng-container *ngIf="phoneElement.control.hasError('invalid') || phoneElement.control.hasError('validatePhoneNumber')">Please enter a valid {{ label }}.
            </ng-container>
        </mat-error>
    </mat-form-field>
</ng-container>

<ng-container *ngIf="prefilled">
    <mat-form-field class="mat-form-field-fluid">
        <mat-label [attr.data-test-id]="testId + '.prefilled-label'">{{ label }}</mat-label>
        <input #phoneInput="ngModel"
               [(ngModel)]="value" matInput
               [attr.data-test-id]="testId + '.prefilled-input'"
               name="phone" [disabled]="true"
               required
               type="text"/>
        <mat-icon matSuffix (click)="editPrefilledNumber()" style="cursor: pointer" [attr.data-test-id]="testId + '.prefilled-edit-icon'">edit</mat-icon>
    </mat-form-field>
</ng-container>
